<!-- form-square-settings.component.html -->
<mat-card class="configuration-card square-settings-card">
  <mat-card-content>
    <form [formGroup]="squareSettingsForm">
      <mat-progress-spinner
        class="matProgressSpinnerCentered"
        *ngIf="showProgressSpinner"
        mode="indeterminate">
      </mat-progress-spinner>

      <ng-container *ngIf="!showProgressSpinner">

        <!-- Connection status hero. Hidden until the settings load resolves so
             the disconnected state never flashes before the real status. -->
        <div class="status-hero" *ngIf="settingsLoaded" [class.is-disconnected]="!isAuthorized">
          <div class="status-ring">
            <mat-icon>{{ isAuthorized ? 'check_circle' : 'error' }}</mat-icon>
          </div>
          <div class="status-text">
            <h2>
              {{ isAuthorized ? 'Connected to Square' : 'Not connected' }}
              <span class="environment-badge" [ngClass]="currentEnvironment">{{ currentEnvironment }}</span>
            </h2>
            <p *ngIf="isAuthorized">Your account is authorized and ready to accept payments.</p>
            <p *ngIf="!isAuthorized">Authorize access to your Square account to start accepting payments.</p>
          </div>
          <div class="status-actions">
            <button *ngIf="!isAuthorized" mat-flat-button color="primary" type="button" (click)="authorizeSquare()">
              <mat-icon>vpn_key</mat-icon> Authorize Square
            </button>
          </div>
        </div>

        <!-- Inline, recoverable error banner. Covers both connected and
             disconnected states; shows the actual error text. -->
        <div class="inline-banner banner-error" *ngIf="errorMessage">
          <mat-icon>error_outline</mat-icon>
          <div class="banner-body">
            <strong>Something went wrong</strong>
            <span>{{ errorMessage }}</span>
          </div>
          <button *ngIf="isAuthorized" mat-stroked-button type="button" class="banner-retry" (click)="fetchLocations()">
            <mat-icon>refresh</mat-icon> Retry
          </button>
        </div>

        <!-- Primary actions (only when connected) -->
        <div class="action-bar" *ngIf="isAuthorized">
          <button mat-flat-button color="primary" type="button" (click)="onSubmit()">
            <mat-icon>save</mat-icon> Save Settings
          </button>
          <button mat-stroked-button type="button" (click)="addTerminalDevice()">
            <mat-icon>add_circle</mat-icon> Add Terminal Device
          </button>
          <span class="action-spring"></span>
          <button mat-stroked-button color="warn" type="button" (click)="deauthorizeSquare()">
            <mat-icon>link_off</mat-icon> Deauthorize
          </button>
        </div>

        <!-- Location settings -->
        <div class="section location-section" *ngIf="isAuthorized">
          <div class="section-head">
            <mat-icon class="section-icon">place</mat-icon>
            <div>
              <h3 class="section-title">Location</h3>
              <p class="section-sub">Payments and reporting are scoped to this Square location.</p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="location-field">
            <mat-label>Square Location</mat-label>
            <mat-select formControlName="squareLocationId" (selectionChange)="onLocationChange()" required>
              <mat-option *ngFor="let location of locations" [value]="location.id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="selected-location-details" *ngIf="selectedLocation">
            <span class="location-status" [ngClass]="selectedLocation.status?.toLowerCase()">
              {{ selectedLocation.status }}
            </span>
            <div class="location-address" *ngIf="selectedLocation.address">
              {{ selectedLocation.address.address_line_1 }}<br>
              {{ selectedLocation.address.locality }}, {{ selectedLocation.address.administrative_district_level_1 }} {{ selectedLocation.address.postal_code }}
            </div>
          </div>

          <div class="location-actions">
            <button mat-button type="button" (click)="fetchLocations()">
              <mat-icon>refresh</mat-icon> Refresh Locations
            </button>
          </div>
        </div>

        <app-success-message [message]="successMessage"></app-success-message>

      </ng-container>
    </form>
  </mat-card-content>
</mat-card>
